import React, { useEffect, useState } from 'react';
import { Button, Card, CardBody, Col, Container, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import { AsyncPaginate } from 'react-select-async-paginate';
import axios from 'axios';
import { adminAPIURL } from '../../../../../../../Config';
import Select from 'react-select';
import { useDispatch, useSelector } from 'react-redux';
import { GET_CAR_TYPE } from '../../../../../../../../store/actions';
import { isValidEmail } from '../../../../../../../Helpers/Helpers';
import cogoToast from 'cogo-toast';
import AddCarType from '../../../../ProgramOnboarding/Components/SelectVendor/Components/Modal/AddCarType';
import { Loader } from '../../../../../../../Common';

const currencyOptions = [
  { label: 'INR', value: 'INR' },
  { label: 'AED', value: 'AED' },
  { label: 'Dollar', value: 'Dollar' },
  { label: 'Euro', value: 'Euro' },
];

const AddClient = ({ client, setClient, errors, setErrors, state }) => {
  const dispatch = useDispatch();
  const [carTypeOptions, setCarTypeOptions] = useState([]);
  const [isShowCarTypeModal, setIsShowCarTypeModal] = useState(false);

  const { getCarType, getCarTypeLoading } = useSelector((state: any) => ({
    getCarType: state.GetCarType.data,
    getCarTypeLoading: state.GetCarType.loading,
  }));

  useEffect(() => {
    dispatch({ type: GET_CAR_TYPE });
  }, []);

  useEffect(() => {
    if (getCarType !== null) {
      setCarTypeOptions(getCarType?.data ?? []);
    }
  }, [getCarType]);

  const handleChange = (field, value) => {
    setClient(prev => ({
      ...prev,
      [field]: value,
    }));
    setErrors(prev => ({
      ...prev,
      [field]: '',
    }));
  };

  const handleCarTypeClick = type => {
    const isSelected = client?.selectedCarTypes?.some(selected => selected.id === type.id);
    const updatedTypes = isSelected ? client.selectedCarTypes.filter(t => t.id !== type.id) : [...client.selectedCarTypes, type];
    handleChange('selectedCarTypes', updatedTypes);
  };

  const handleAddCarType = data => {
    setCarTypeOptions(prev => [...prev, data]);
    const existCarTypes = client.selectedCarTypes ?? [];
    existCarTypes.push(data);
    handleChange('selectedCarTypes', existCarTypes);
    setIsShowCarTypeModal(false);
  };

  async function loadOptions(search) {
    const response = await axios.get(`${adminAPIURL}/v1/client/countries`, {
      headers: { 'Project-Code': 'ADMIN_ACCESS' },
      params: { name: search },
      withCredentials: true,
    });

    return {
      options: response?.data?.results?.countries?.map(data => ({
        value: data.id,
        label: data.name,
        completeData: data,
      })),
      hasMore: false,
    };
  }

  const onSelectRegion = region => {
    setClient(prev => ({
      ...prev,
      region,
      currency: region?.completeData?.currency,
    }));
  };

  return (
    <>
      {getCarTypeLoading && <Loader />}
      {isShowCarTypeModal && (
        <AddCarType
          onClose={() => {
            setIsShowCarTypeModal(false);
          }}
          handleAddCarType={handleAddCarType}
        />
      )}
      <Row className="mb-3">
        <Col md={3} className="mb-2">
          <Label for="name">Name</Label>
          <Input
            type="text"
            id="name"
            value={client.name}
            onChange={e => handleChange('name', e.target.value)}
            invalid={!!errors.name}
            placeholder="Client Name"
          />
          {errors.name && <div className="text-danger small">{errors.name}</div>}
        </Col>

        <Col md={3} className="mb-2">
          <Label for="region">Region</Label>
          <AsyncPaginate
            debounceTimeout={500}
            value={client.region}
            loadOptions={loadOptions}
            onChange={onSelectRegion}
            isMulti={false}
            closeMenuOnSelect
            noOptionsMessage={() => 'No results found'}
            cacheUniqs={[['code']]}
            placeholder=""
          />
          {errors.region && <div className="text-danger small">{errors.region}</div>}
        </Col>

        <Col md={3} className="mb-2">
          <Label for="currency">Currency</Label>
          <Input type="text" id="currency" value={client.currency} invalid={!!errors.currency} disabled />
          {errors.currency && <div className="text-danger small">{errors.currency}</div>}
        </Col>

        <Col md={3} className="mb-2">
          <Label for="name">Client Type</Label>
          <Input
            type="text"
            id="name"
            value={client.client_type}
            onChange={e => handleChange('client_type', e.target.value)}
            invalid={!!errors.client_type}
            placeholder="Client Type"
          />
          {errors.name && <div className="text-danger small">{errors.client_type}</div>}
        </Col>

        <Col md={3} className="mb-2">
          <Label for="name">Industry</Label>
          <Input
            type="text"
            id="name"
            value={client.industry}
            onChange={e => handleChange('industry', e.target.value)}
            invalid={!!errors.industry}
            placeholder="Industry"
          />
          {errors.name && <div className="text-danger small">{errors.industry}</div>}
        </Col>
      </Row>

      <Label>Car Type</Label>
      <div className="d-flex flex-wrap gap-2">
        {carTypeOptions?.map((type, idx) => {
          const isSelected = client?.selectedCarTypes?.some(selected => selected.id === type.id);
          return (
            <div
              key={idx}
              onClick={() => handleCarTypeClick(type)}
              className="p-2 cursor-pointer"
              style={{
                borderRadius: '25px',
                color: '#6F7594',
                border: isSelected ? '1px solid #405189' : '1px solid #D0D2DC',
                background: isSelected ? '#ABB9E8' : 'transparent',
              }}
            >
              {type?.name?.split(' ')[0] ?? ''}
            </div>
          );
        })}

        {/* <Button color="primary" className="rounded-pill" type="button" onClick={() => setIsShowCarTypeModal(true)}>
          + Add Car Type
        </Button> */}
      </div>
      {errors.selectedCarTypes && <div className="text-danger small mt-1">{errors.selectedCarTypes}</div>}
    </>
  );
};

export default AddClient;
